(() => {
  const key = "isshiki-contact-attribution";
  const params = new URLSearchParams(window.location.search);
  const fields = ["gclid", "gbraid", "wbraid", "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
  const detailsKey = `${key}-details`;
  let attribution = null;
  let details = null;

  try {
    attribution = JSON.parse(sessionStorage.getItem(key));
  } catch (_) {}

  try {
    details = JSON.parse(sessionStorage.getItem(detailsKey));
  } catch (_) {}
  if (!details || typeof details !== "object" || Array.isArray(details)) details = null;

  if (fields.some((field) => params.get(field))) {
    details = Object.fromEntries(fields.filter((field) => params.get(field)).map((field) => [field, params.get(field)]));
    details.landing_page = window.location.origin + window.location.pathname;
    try {
      sessionStorage.setItem(detailsKey, JSON.stringify(details));
    } catch (_) {
      try { sessionStorage.removeItem(detailsKey); } catch (_) {}
    }
  }

  if (typeof attribution === "string" && attribution.startsWith("Source:")) {
    attribution = attribution.startsWith("Source: Google Ads") ? "Google Ads" : null;
  }

  if (fields.some((field) => params.get(field)) || !attribution) {
    const source = (params.get("utm_source") || "").toLowerCase();
    const medium = (params.get("utm_medium") || "").toLowerCase();
    const paid = /^(cpc|ppc|paidsearch|paid|display|paid_social)$/.test(medium);
    let referrer = null;
    try {
      referrer = document.referrer ? new URL(document.referrer) : null;
    } catch (_) {}
    const external = referrer && referrer.hostname !== window.location.hostname;
    const search = external && /(^|\.)(google\.(?:[a-z]{2,3}|(?:co|com)\.[a-z]{2})|bing\.com|search\.yahoo\.com|duckduckgo\.com|ecosia\.org|search\.brave\.com)$/.test(referrer.hostname);
    attribution = ["gclid", "gbraid", "wbraid"].some((field) => params.get(field)) || (source === "google" && paid)
      ? "Google Ads"
      : medium === "email" ? "Email"
      : paid ? "Other Ads"
      : medium === "organic" || (!source && search) ? "Search"
      : /^(social|social-network|social-media)$/.test(medium) ? "Social"
      : source || external ? "Referral"
      : referrer ? "Unknown" : "Direct";
    try {
      sessionStorage.setItem(key, JSON.stringify(attribution));
    } catch (_) {
      try { sessionStorage.removeItem(key); } catch (_) {}
    }
  }

  if (typeof attribution === "string") {
    // Keep the existing wholesale contact links in the session that holds the source.
    document.querySelectorAll('a[target="_blank"]').forEach((link) => {
      let url;
      try {
        url = new URL(link.href);
      } catch (_) { return; }
      if (url.origin === window.location.origin && url.pathname === "/pages/contact") link.target = "_self";
    });
  }

  const form = document.getElementById("ContactForm");
  if (!form) return;

  const input = document.createElement("input");
  input.type = "hidden";
  input.name = "contact[Source]";
  input.value = attribution;
  form.appendChild(input);

  if (details) {
    [...fields, "landing_page"].forEach((field) => {
      if (typeof details[field] !== "string" || !details[field]) return;
      const detailInput = document.createElement("input");
      detailInput.type = "hidden";
      detailInput.name = `contact[${field}]`;
      detailInput.value = details[field];
      form.appendChild(detailInput);
    });
  }
})();
